import * as React from 'react';
import { RulesMessages, ValidationResponse } from '../utils/validator';
import NumericInput from './NumericInput';
import routingInfoDetails from '../utils/bankRoutingNumbers';
import { HatType } from './Hat';

interface RoutingNumberInputProps {
  placeHolder?: string;
  value?: string;
  name: string;
  id: string;
  label?: string;
  theme?: 'night' | 'day';
  required?: boolean;
  hasError: boolean;
  errors?: any;
  onChange?: Function;
  onComplete?: Function;
  rulesMessages?: RulesMessages;
  onError?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  languageCode?: string;
}

interface RoutingNumberInputState {
  inputValue: string;
  validationResponse?: ValidationResponse;
}

export default function RoutingNumberInput(props: RoutingNumberInputProps) {
  const [state, setState] = React.useState<RoutingNumberInputState>({
    inputValue: props.value || ''
  });

  return (
    <NumericInput
      placeHolder={props.placeHolder}
      value={state.inputValue}
      name={props.name}
      id={props.id}
      rulesMessages={props.rulesMessages}
      label={props.label || 'Routing Number'}
      theme={props.theme}
      required={props.required}
      hasError={props.hasError}
      errors={props.errors}
      onComplete={props.onComplete}
      onError={props.onError}
      onChange={(event: any) => {
        const { target } = event;
        const inputValue = target.value;
        setState({ ...state, inputValue });
        const matchedBank = routingInfoDetails.find(bank =>
          bank.routingNumbers.includes(inputValue)
        );
        let finalBank = {
          name: 'New Bank',
          code: 'NEWBANK'
        };
        if (matchedBank) {
          finalBank = {
            name: matchedBank.name,
            code: matchedBank.code
          };
        }
        if (props.onChange !== undefined) {
          props.onChange({
            ...event,
            target: { ...event.target, bank: finalBank }
          });
        }
      }}
      maxLength={9}
      minLength={9}
      hat={props.hat}
      readOnly={props.readOnly}
      disabled={props.disabled}
      useRulesMessagesProp={props.languageCode!="es"}
    />
  );
}
